import { SECTION, THREAD_STATE, THREAD_STATE_ACTIONS, THREAD_STATE_ACTIONS_GROUPS } from "@/features/messaging/constants";

export function matchThreadView(thread, view) {
    const state = thread?.member_thread_state;
    const isStarred = !!thread?.member_is_thread_starred;

    switch (view) {
        case SECTION.INBOX:
            return state === THREAD_STATE.INBOX;

        case SECTION.STARRED:
            return isStarred && state !== THREAD_STATE.TRASHED && state !== THREAD_STATE.DELETED;

        case SECTION.TRASHED:
            return state === THREAD_STATE.TRASHED;

        default:
            return false;
    }
}

export function computeThreadCounts(threads) {
    let inboxCount = 0, starredCount = 0, trashedCount = 0;
    for (const thread of threads) {
        const state = thread.member_thread_state;
        const isRead = !!thread.member_is_thread_read;
        const isStarred = !!thread.member_is_thread_starred;

        if (state === THREAD_STATE.INBOX && !isRead) {
            inboxCount++;
        }
        if (isStarred && state !== THREAD_STATE.TRASHED && state !== THREAD_STATE.DELETED && !isRead) {
            starredCount++;
        }
        if (state === THREAD_STATE.TRASHED && !isRead) {
            trashedCount++;
        }
    }
    return { inboxCount, starredCount, trashedCount };
}

export function isThreadStarred(thread) {
    return Boolean(thread?.member_is_thread_starred);
}
export function isThreadTrashed(thread) {
    return thread?.member_thread_state === THREAD_STATE.TRASHED;
}
export function getToggleStartAction(isStarred) {
    return isStarred ? THREAD_STATE_ACTIONS.UNSTAR : THREAD_STATE_ACTIONS.STAR;
}
export function getToggleTrashAction(isTrashed) {
    return isTrashed ? THREAD_STATE_ACTIONS.RESTORE : THREAD_STATE_ACTIONS.TRASH;
}
export function getReservationId(thread) {
    return thread?.metadata?.reservation_id ?? null;
}

export function doesActionAffectUnreadThreadsCount(action) {
    return THREAD_STATE_ACTIONS_GROUPS.AFFECT_UNREAD_COUNT.includes(action);
}


// WEBPACK FOOTER //
// ./src/features/messaging/utils/threads.js